import { toJson } from "kreate-common/modules/json-utils";

import { assert } from "@/modules/common-utils/assert";
import { shamelesslyRevalidateEverything } from "@/modules/common-utils/shamelesslyRevalidateEverything";
import ModalAlert from "@/modules/kreate-modals/modals/ModalAlert";
import { waitModal } from "@/modules/kreate-modals/modals/ModalAsyncGenerator/hooks";
import ModalConfirm from "@/modules/kreate-modals/modals/ModalConfirm";
import ModalProgressV2 from "@/modules/kreate-modals/modals/ModalProgressV2";

export default async function* runFlow$UpdateVerification(params: {
  userId: string;
  newVerified: boolean;
}) {
  yield* waitModal<void>((resolve, reject) => (
    <ModalConfirm
      open
      onAccept={resolve}
      onReject={() => reject(null)}
      message={`Do you want to ${
        params.newVerified ? "verify" : "unverify"
      } this user?`}
    />
  ));
  yield (
    <ModalProgressV2
      open
      content="Loading..."
      ratio={[0, 1]}
      expectedDuration={500}
    />
  );
  const response = await fetch("/api/v1/admin/update-verification", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accepts: "application/json",
    },
    body: toJson(params),
  });
  assert(response.ok, "response not ok");
  await shamelesslyRevalidateEverything();
  yield* waitModal<void>((resolve) => (
    <ModalAlert
      open
      onClose={resolve}
      message={`${
        params.newVerified ? "Verified" : "Unverified"
      } successfully!`}
    />
  ));
}
